var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeButton"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.click}},[_c('i',{staticClass:"fas fa-times"})])])}
var staticRenderFns = []

export { render, staticRenderFns }